import Vue from 'vue'
import VueRouter from 'vue-router'
import users from './user'
import favor from './favor'
import msgs from './msg'


Vue.use(VueRouter)

const routesChild = [...msgs]

routesChild.forEach(e=>{
  favor[0].children.push(e)
})

let routes = [...users,...favor];
const router = new VueRouter({
  routes,
  mode: "history"

})

//解决重复路由问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
